import {useMemo} from 'react'

import PropTypes from 'prop-types'

import FilterBasic from '@adv-mt/mt-filter-basic'

import {getCurrentOptions} from '../utils/filterUtils.js'

const FilterWrapperBasicFilter = ({
  allSelectionsId,
  allSelectionsImageSrc,
  allSelectionsLabel,
  chips,
  description,
  design,
  isFullWidth,
  group,
  id,
  inputSearch,
  label,
  name,
  nodeLabel,
  onBlur,
  onChange,
  onFocus,
  options,
  placeholder,
  showLabel,
  suffix,
  suffixIcon,
  type,
  value,
  withDivider,
  withLabel
}) => {
  const currentOptions = useMemo(
    () => (inputSearch ? getCurrentOptions({options, search: inputSearch}) : options),
    [options, inputSearch]
  )

  return (
    <FilterBasic
      allSelectionsId={allSelectionsId}
      allSelectionsImageSrc={allSelectionsImageSrc}
      allSelectionsLabel={!inputSearch && allSelectionsLabel}
      chips={chips}
      description={description}
      design={design}
      htmlFor={group ? `${group}-${name}` : name}
      id={id}
      isFullWidth={isFullWidth}
      label={label}
      nodeLabel={nodeLabel}
      onBlur={onBlur}
      onChange={newValue => onChange({group, name, value: newValue})}
      onFocus={onFocus}
      options={currentOptions}
      placeholder={placeholder}
      showLabel={showLabel}
      suffix={suffix}
      suffixIcon={suffixIcon}
      type={type}
      value={value}
      withDivider={withDivider}
      withLabel={withLabel}
    />
  )
}

FilterWrapperBasicFilter.displayName = 'FilterWrapperBasicFilter'
FilterWrapperBasicFilter.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsImageSrc: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  chips: PropTypes.arrayOf(PropTypes.number),
  description: PropTypes.string,
  design: PropTypes.string,
  isFullWidth: PropTypes.bool,
  group: PropTypes.string,
  id: PropTypes.array,
  inputSearch: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.node,
      id: PropTypes.string,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string,
      nestedItems: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string
        })
      )
    })
  ),
  placeholder: PropTypes.string,
  nodeLabel: PropTypes.node,
  showLabel: PropTypes.bool,
  suffix: PropTypes.string,
  suffixIcon: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.object,
  withDivider: PropTypes.bool,
  withLabel: PropTypes.bool
}

export default FilterWrapperBasicFilter
